'use strict';
'use es6';
'babel mixed-exports';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = undefined;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logShown = {};

var shouldLog = function shouldLog(key) {
  return !_enviro2.default.deployed() && (key == null || !logShown[key]);
};

var markAsShown = function markAsShown(key) {
  if (key) {
    logShown[key] = true;
  }
};

var warn = exports.warn = function warn(_ref) {
  var _ref$message = _ref.message,
      message = _ref$message === undefined ? '' : _ref$message,
      key = _ref.key,
      url = _ref.url;

  if (url) {
    message += '\nFor details, see: ' + url;
  }

  if (shouldLog(key)) {
    // eslint-disable-next-line no-console
    console.warn(message);
    markAsShown(key);
  }
};

exports.default = {
  warn: warn
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.43/js/devLogger.js
// module id = 5
// module chunks = 0